import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';

import { WorkingDayOrder } from '../working-day-order';
import { WorkingHourProofBuilder } from './working-hour-proof.builder';
import { WorkingHourBuilder } from './working-hour.builder';

export class WorkingDayOrderBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingDayOrder(
        json.hash,
        json.userHash,
        json.userName,
        json.userLastName,
        parseNumber(json.userReference),
        json.userRole,
        json.userWorkingShiftHash,
        json.workingShiftHash,
        json.workingShiftName,
        json.workingShiftHasBreak,
        json.workingShiftBreakTime,
        json.information,
        json.date,
        json.totalTime,
        json.extraTime,
        (json.workingHours) ? WorkingHourBuilder.fromList(json.workingHours) : [],
        (json.workingHourProofs) ? WorkingHourProofBuilder.fromList(json.workingHourProofs) : []
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WorkingDayOrderBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-day-order.builder.ts